import { NotificationTypes } from './notification-types';

export default class Notification<T = any> {
    SystemProcessKey: string = '';
    Title: string = '';
    Message: string = '';
    Type: NotificationTypes = NotificationTypes.Info;
    AdditionalData?: T;
}